import type { AxiosInstance } from "axios";

const LOGICALUNIT_URL = "/U3201";

export const U3201Endpoints = {
  OAUTH_AUTHORIZE_URL: (orgId: string) => `${LOGICALUNIT_URL}/oauth/authorize-url/${orgId}`,
  STATUS: (orgId: string) => `${LOGICALUNIT_URL}/status/${orgId}`,
  DISCONNECT: (orgId: string) => `${LOGICALUNIT_URL}/disconnect/${orgId}`,
};

export interface U3201GoogleCalendarStatus {
  connected: boolean;
  oauthConfigured: boolean;
  calendarId?: string | null;
}

export interface U3201GoogleCalendarDisconnectResult {
  disconnected: boolean;
}

export const doGetOAuthAuthorizeUrl = (axios: AxiosInstance, orgId: string) =>
  axios.get<{ result: { url: string } }>(U3201Endpoints.OAUTH_AUTHORIZE_URL(orgId));

export const doGetGoogleCalendarStatus = (axios: AxiosInstance, orgId: string) =>
  axios.get<{ result: U3201GoogleCalendarStatus }>(U3201Endpoints.STATUS(orgId));

export const doDisconnectGoogleCalendar = (axios: AxiosInstance, orgId: string) =>
  axios.delete<{ result: U3201GoogleCalendarDisconnectResult }>(U3201Endpoints.DISCONNECT(orgId));
